import {uniqueId} from 'lodash'

const creditNotesTable = {
  columns: {
    getColumnsData: 'creditNotesColumnsData',
    setColumnsData: 'setCreditNotesColumnsData'
  },
  rows: {
    getRowsData: 'creditNotesRowsData',
    setRowsData: 'setCreditNotesRowsData'
  }
}

const columns = [
  {
    title: 'credit note no.',
    property: 'notesNumber',
    editable: true,
    style: 'long-input',
    sort: true,
    typeEditable: 'inputString',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    inputs: ['amountAED'],
    type: 'upload',
    upload: true,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'balance',
    isNumber: true,
    property: 'consumedBalance',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'date',
    property: 'date',
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'client name',
    sort: true,
    property: 'clientName.nickName',
    propertyWrite: 'clientName',
    editable: true,
    typeEditable: 'select',
    listName: 'clientsList',
    placeholder: 'Set Client',
    list: [],
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'amount',
    isNumber: true,
    property: 'amount',
    editable: true,
    typeEditable: 'inputNumber',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'Against Inv. No.',
    property: 'againstInvoice',
    editable: true,
    style: 'long-input',
    typeEditable: 'inputString',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'consumed',
    sortByColumn: true,
    property: 'consumed',
    style: 'project',
    center: true,
    type: 'toggle',
    list: [{id: true, name: 'consumed'}, {id: false, name: 'not consumed'}],
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    property: 'consumedInvoice',
    editable: true,
    typeEditable: 'array',
    inputs: ['amount'],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    property: 'action',
    inputs: ['amountAED'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false,
      upload: true
    }
  }
]

const prefix = 'credit_notes_column_'
const creditNotesTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  col.typeTable = 'creditNotes'
  return col
})

export {creditNotesTable, creditNotesTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/creditNotesTable.js